/**
 * The screen a Report a problem report was raised on, in the words the user sees, from the
 * route in `app.tsx` (#659). A path no screen matches is sent as the path itself.
 */
const SCREENS: { pattern: RegExp; name: string }[] = [
  { pattern: /^\/?$/, name: 'Jobs' },
  { pattern: /^\/job\/[^/]+\/?$/, name: 'Job' },
  { pattern: /^\/job\/[^/]+\/take-off\/[^/]+\/?$/, name: 'Take off' },
  { pattern: /^\/job\/[^/]+\/schedule\/[^/]+\/?$/, name: 'Schedule of Work' },
  { pattern: /^\/job\/[^/]+\/site-plan\/?$/, name: 'Site plan' },
];

export function screenName(path: string): string {
  return SCREENS.find((s) => s.pattern.test(path))?.name ?? path;
}
